export default __webpack_public_path__ + "static/media/DonutChart.4e54bd6a.svg";